<template>
  <ValidationObserver
    ref="form"
    slim
  >
    <form
      role="form"
      class="form-horizontal"
      name="vm.jornayaSetting"
      novalidate=""
      @submit.prevent
    >
      <fieldset>
        <Field
          :label="$t('ACCOUNT_CODE')"
          :has-tooltip="true"
          :tooltip-text="$t('ACCOUNT_CODE_TT')"
        >
          <template #element>
            <ValidationProvider
              v-slot="{ classes }"
              ref="accountCode"
              rules="required"
              slim
            >
              <div :class="classes">
                <div class="col-sm-5 col-md-3">
                  <input
                    v-model="jornayaSettingContext.accountCode"
                    type="text"
                    class="form-control"
                    @input="onInput"
                    @change="onChange"
                  >
                </div>
                <label
                  v-t="'REQUIRED'"
                  class="col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                />
              </div>
            </ValidationProvider>
          </template>
        </Field>
        <Field
          :label="$t('AGENCY_CODE')"
          :has-tooltip="true"
          :tooltip-text="$t('AGENCY_CODE_TT')"
        >
          <template #element>
            <ValidationProvider
              v-slot="{ classes }"
              ref="agencyCode"
              rules="required"
              slim
            > 
              <div :class="classes">
                <div class="col-sm-5 col-md-3">
                  <input
                    v-model="jornayaSettingContext.agencyCode"
                    type="text"
                    class="form-control"
                    @input="onInput"
                    @change="onChange"
                  >
                </div>
                <label
                  v-t="'REQUIRED'"
                  class="col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                />
              </div>
            </ValidationProvider>
          </template>
        </Field>
        <Field
          :label="$t('AUDIT_KEY')"
          :has-tooltip="true"
          :tooltip-text="$t('AUDIT_KEY_TT')"
        >
          <template #element>
            <ValidationProvider
              v-slot="{ classes }"
              ref="auditKey"
              rules="required"
              slim
            > 
              <div :class="classes">
                <div class="col-sm-5 col-md-3">
                  <input
                    v-model="jornayaSettingContext.auditKey"
                    type="text"
                    class="form-control"
                    @input="onInput"
                    @change="onChange"
                  >
                </div>
                <label
                  v-t="'REQUIRED'"
                  class="col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                />
              </div>
            </ValidationProvider>
          </template>
        </Field>
      </fieldset>
    </form>
  </ValidationObserver>
</template>

<script>

import Field from '@/core/components/LabelAndElement/LabelAndElement';
import messages from './locales';

export default {
  name: 'JornayaSettings',
  components: {
    Field
  }, 

  props: {
    jornayaSetting: {
      type: Object,
      default: null
    },
  },

  data() {
    return {
      jornayaSettingContext: this.jornayaSetting,
      defaultSetting: {
        accountCode: null,
        auditKey: null,
        agencyCode: null
      }
    };
  },

  watch: {
    'jornayaSetting'() {
      this.jornayaSettingContext = this.jornayaSetting;
    },
  },

  created() {
    if (!this.jornayaSettingContext) {
      this.jornayaSettingContext = this.defaultSetting;
    }
  },

  methods: {
    onInput() {
      this.bubbleChanges();
    },

    onChange() {
      this.bubbleChanges();
    },

    async bubbleChanges() {
      const valid = await this.$refs.form.validate();

      this.$emit('jornayaSettingsChange', { isFormValid: valid, value: this.jornayaSettingContext });
    }
  },

  i18n: {
    messages,
    locale: 'en'
  } 
};
</script>

<style>

</style>